import styled from 'styled-components';


const Img = styled.img`
    cursor: pointer;
    margin: 10px;
    height: 30px;
    
    @media (max-width: 350px) {
        height: 22px;
        margin: 11px 0px;
    }
`;


export default Img;
